import { Box, Button, Container, Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useState } from 'react';
import bodyLeftBg from '../../../images/Rectangle 302.png';
import bodyRightBg from '../../../images/Vector 70.png';
import bodyTextBg from '../../../images/Vector 93.png';
import OurService from '../OurService/OurService';
import ContactUs from '../../About/ContactUs/ContactUs';

const serviceTextBg = {
    backgroundImage: `url(${bodyLeftBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '30% 80%'
}
const serviceTextRightBg = {
    backgroundImage: `url(${bodyRightBg})`,
    backgroundPosition: 'right top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '8% 100%'
}
const serviceTextLeftBg = {
    backgroundImage: `url(${bodyTextBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100px 100px'
}

const OurServices = () => {
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [displayServices, setDisplayServices] = useState([]);
    const size = 5;
    useEffect(() => {
        fetch(`https://powerful-wildwood-27860.herokuapp.com/services?page=${page}&&size=${size}`)
            .then(res => res.json())
            .then(data => {
                setDisplayServices(data.services);
                const count = data.count;
                const pageNumber = Math.ceil(count / size);
                setPageCount(pageNumber);
            });
    }, [page])
    return (
        <div>
            <Box style={serviceTextBg} sx={{ pb: 4, mt: 2 }}>
                <Container>
                    <Box style={serviceTextLeftBg} sx={{ textAlign: 'left' }}>
                        <Typography variant="h3" id="connect-title" sx={{ pb: 3, color: '#000D83', fontWeight: 600, pl: 4, py: 4 }}>
                            Services
                        </Typography>
                    </Box>
                </Container>
            </Box>
            <Container>
                <Typography variant="h3" id="services-title" sx={{ color: '#000D83', fontWeight: 600, py: 2, textAlign: 'center' }} style={serviceTextRightBg}>
                    We Help Your Business Grow With
                </Typography>
                <Typography sx={{ textAlign: 'left', mx: 3, color: '#5B5B5B', py: 4, fontSize: '18px', lineHeight: '33px' }} id="service-details" variant="body3" component="div">
                    Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena. Lorem ipsum dolor sit amet, consectetur adipiscing Amet pharetra, maecena. consectetur adipiscing Amet pharetra, maecena.
                </Typography>
            </Container>
            <Box id="service-first-left-bg">
                <Box id="service-second-left-bg">
                    <Box id="service-third-left-bg">
                        <Box id="service-first-right-bg">
                            <Box id="service-second-right-bg">
                                <Box id="service-third-right-bg">
                                    <Box id="service-doted-right-first-bg">
                                        <Box id="service-doted-right-second-bg">
                                            <Box id="service-doted-right-third-bg">
                                                <Container sx={{ py: 4 }}>
                                                    <Grid container spacing={4}>
                                                        {
                                                            displayServices.map(service => <OurService
                                                                key={service._id}
                                                                service={service}
                                                            ></OurService>)
                                                        }
                                                    </Grid>
                                                    <Box className='pagination-Button' sx={{ py: 10 }}>
                                                        {
                                                            [...Array(pageCount).keys()].map(number => <Button className={number === page ? 'selected' : 'not-selected'} key={number} onClick={() => setPage(number)}>{number + 1}</Button>)
                                                        }
                                                    </Box>
                                                </Container>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box id="contact-visibility-state">
                <ContactUs />
            </Box>
        </div>
    );
};

export default OurServices;